import React from "react";
import PropTypes from "prop-types";
import CategoriasDesktop from "./CategoriasDesktop";

function PositivacaoCategory({ app, config }) {
  return <CategoriasDesktop app={app} config={config} />;
}

PositivacaoCategory.defaultProps = {
  app: null,
  config: {},
};

PositivacaoCategory.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default PositivacaoCategory;
